<template>
  <div class="yq-information-modify">
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="flexBox">
      <text-title :mainTitle="mainTitle" :subheading="subheading" />
      <div class="header-btn-box">
        <a
          @click="updateyqInfo"
          style="
            display: inline-block;
            width: 89px;
            height: 38px;
            line-height: 38px;
            background: #1362ff;
            border-radius: 8px;
            font-size: 14px;
            color: #fff;
          "
          >保存</a
        >
        <a
          @click="toConfigRoutinePage"
          style="
            display: inline-block;
            width: 89px;
            height: 38px;
            line-height: 38px;
            background: #1362ff;
            border-radius: 8px;
            font-size: 14px;
            color: #fff;
          "
          >取消</a
        >
      </div>
    </div>
    <form class="yq-information-modify-form">
      <div class="form-left">
        <div class="form-top-text">
          <i class="iconfont el-icon-damai-qiye11"></i>基础信息
        </div>
        <div class="form-left-line">
          <div class="textBox" style="justify-content: flex-end">
            <b class="red">*</b>
            <span class="line-text">公寓名称：</span>
          </div>
          <el-input class="line-info" v-model="yqName" size="small" />
        </div>
        <div class="form-left-line">
          <div class="textBox" style="justify-content: flex-end">
            <b class="red">*</b>
            <span class="line-text">公寓联系方式：</span>
          </div>
          <el-input class="line-info" v-model="managerPhone" size="small" />
        </div>
        <div class="form-left-line">
          <div class="textBox" style="justify-content: flex-end">
            <b class="red">*</b>
            <span class="line-text">公寓Logo：</span>
          </div>
          <div class="line-info">
            <input
              id="uploadBackgroundImg"
              name="file"
              accept="image/*"
              type="file"
              @change="upData2"
              style="display: none"
            />
            <div>
              <a class="upload" @click="upImg2" v-if="!yqLogo">
                <span><i class="el-icon-plus"></i></span>
                <b>点击上传</b>
              </a>
              <a class="upload2" @click="upImg2" v-if="yqLogo">
                <img :src="yqLogo" id="packBg" />
                <b>重新上传</b>
              </a>
            </div>
          </div>
        </div>
        <div class="form-left-line">
          <div class="line-text">标准层高：</div>
          <el-input class="line-info" v-model="floorStandardHigh" size="small">
            <template slot="append">m</template>
          </el-input>
        </div>
        <div class="form-left-line">
          <div class="line-text">标准层面积：</div>
          <el-input class="line-info" v-model="floorStandardArea" size="small">
            <template slot="append">m²</template>
          </el-input>
        </div>
        <div class="form-left-line">
          <div class="line-text">佣金规则：</div>
          <el-input class="line-info" v-model="commissionRules" size="small" />
        </div>
        <div class="form-left-line">
          <div class="line-text">物业公司：</div>
          <el-input class="line-info" v-model="propertyCompany" size="small" />
        </div>
        <div class="form-left-line">
          <div class="line-text">交付运营时间：</div>
          <el-date-picker
            v-model="startOperationTime"
            value-format="yyyy-MM-dd"
            type="date"
            size="small"
            class="line-info"
            placeholder="选择日期"
          >
          </el-date-picker>
        </div>
        <div class="form-left-line">
          <div class="line-text">交付标准：</div>
          <el-select
            v-model="roomDecoration"
            placeholder="请选择"
            size="mini"
            class="line-info"
          >
            <el-option
              v-for="item in roomDecorationList"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            />
          </el-select>
        </div>
        <div class="form-left-line">
          <div class="line-text">公寓租赁单价：</div>
          <el-input class="line-info" v-model="yqUnitPrice" size="small">
            <template slot="append">元 / m² / 天</template>
          </el-input>
        </div>
        <div class="form-left-line">
          <div class="line-text">公寓物业单价：</div>
          <el-input class="line-info" v-model="propertyFee" size="small">
            <template slot="append">元 / m² / 月</template>
          </el-input>
        </div>
        <div class="form-left-line">
          <div class="line-text">公寓标签：</div>
          <div
            class="line-info"
            style="
              flex: 1;
              line-height: 35px;
              width: auto;
              display: flex;
              justify-content: flex-start;
              flex-wrap: wrap;
              align-items: center;
            "
          >
            <el-tag
              :key="tag"
              v-for="tag in dynamicTags"
              closable
              :disable-transitions="false"
              @close="handleClose(tag)"
              >{{ tag }}</el-tag
            >
            <el-input
              class="input-new-tag"
              v-if="inputVisible"
              v-model="inputValue"
              ref="saveTagInput"
              size="small"
              @keyup.enter.native="handleInputConfirm"
              @blur="handleInputConfirm"
            >
            </el-input>
            <el-button
              v-else
              class="button-new-tag"
              size="small"
              @click="showInput"
              >添加新标签</el-button
            >
          </div>
        </div>

        <div class="form-left-line">
          <div class="line-text">公寓展示图：</div>
          <upload-img-list
            @getImgList="getImgList"
            :defaultImg="defaultImg"
            style="flex-wrap: wrap"
          />
        </div>
<!--        <div class="form-left-line">
          <div class="line-text">公寓户型图：</div>
          <upload-img-list
            @getImgList="getApartmentLayoutImgList"
            :defaultImg="defaultApartmentLayoutImg"
            style="flex-wrap: wrap"
          />
        </div>-->
      </div>

      <div class="form-right">
        <!-- <div class="form-right-top">
          <div class="form-top-text">
            <i class="iconfont el-icon-damai-dizhi"></i>公寓地址
          </div>
          <div class="form-left-line">
            <div style="width: 480px; margin: 10px auto">
              <garden-map
                :isModify="true"
                :defaultAdd="yqAddress"
                :longitude="longitude"
                :latitude="latitude"
                @getAddress="getAddress"
              />
            </div>
          </div>
        </div> -->
        <div class="form-right-bottom">
          <div class="form-top-text">
            <i class="iconfont el-icon-damai-jieshao"></i>公寓简介
          </div>
          <div class="editorBox">
            <quill-editor
              ref="QuillEditor"
              v-model="yqIntroduce"
              class="ql-editor"
              :options="editorOption"
              @blur="onEditorBlur($event)"
              @focus="onEditorFocus($event)"
              @ready="onEditorReady($event)"
            >
            </quill-editor>
          </div>
        </div>
      </div>
    </form>

    <!--    <form>-->
    <!--      <div class="form-line">-->
    <!--        <div style="display: flex;justify-content: flex-start;">-->
    <!--          <div class="textBox">-->
    <!--            <b class="red">*</b>-->
    <!--            <span class="line-text">公寓名称：</span>-->
    <!--          </div>-->
    <!--          <div class="line-info">-->
    <!--            <el-input v-model="yqName" size="small" style="width: 220px" />-->
    <!--          </div>-->
    <!--        </div>-->
    <!--        <div style="display: flex;justify-content: flex-start;">-->
    <!--          <div class="textBox">-->
    <!--            <b class="red">*</b>-->
    <!--            <span class="line-text">公寓联系方式：</span>-->
    <!--          </div>-->
    <!--          <div class="line-info">-->
    <!--            <el-input v-model="managerPhone" size="small" style="width: 220px" />-->
    <!--          </div>-->
    <!--        </div>-->
    <!--        <div class="form-line" style="display: flex;justify-content: flex-start;">-->
    <!--          <div class="textBox" style="justify-content: flex-end;">-->
    <!--            <b class="red">*</b>-->
    <!--            <span class="line-text" >公寓Logo：</span>-->
    <!--          </div>-->
    <!--          <div class="line-info">-->
    <!--            <input id="uploadBackgroundImg" name="file" accept="image/*" type="file"-->
    <!--                   @change="upData2" style="display: none" />-->
    <!--            <div>-->
    <!--              <a class="upload" @click="upImg2" v-if="!yqLogo">-->
    <!--                <span><i class="el-icon-plus"></i></span>-->
    <!--                <span>点击上传</span>-->
    <!--              </a>-->
    <!--              <a class="upload2" @click="upImg2" v-if="yqLogo">-->
    <!--                <img :src="yqLogo" id="packBg" />-->
    <!--                <b>重新上传</b>-->
    <!--              </a>-->
    <!--            </div>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </div>-->

    <!--      <div class="form-line">-->
    <!--        <div style="display: flex;justify-content: flex-start;">-->
    <!--          <div class="textBox">-->
    <!--            <b class="red"></b>-->
    <!--            <span class="line-text">标准层高：</span>-->
    <!--          </div>-->
    <!--          <div class="line-info" style="line-height: 35px">-->
    <!--            <el-input v-model="floorStandardHigh" size="small" style="width: 220px">-->
    <!--              <template slot="append">m</template>-->
    <!--            </el-input>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--        <div style="display: flex;justify-content: flex-start;">-->
    <!--          <div class="textBox">-->
    <!--            <b class="red"></b>-->
    <!--            <span class="line-text">标准层面积：</span>-->
    <!--          </div>-->
    <!--          <div class="line-info" style="line-height: 35px">-->
    <!--            <el-input v-model="floorStandardArea" size="small" style="width: 220px">-->
    <!--              <template slot="append">m²</template>-->
    <!--            </el-input>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--        <div style="display: flex;justify-content: flex-start;">-->
    <!--          <div class="textBox">-->
    <!--            <b class="red"></b>-->
    <!--            <span class="line-text">佣金规则：</span>-->
    <!--          </div>-->
    <!--          <div class="line-info">-->
    <!--            <el-input v-model="commissionRules" size="small" style="width: 220px" />-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </div>-->

    <!--      <div class="form-line">-->
    <!--        <div style="display: flex;justify-content: flex-start;">-->
    <!--          <div class="textBox">-->
    <!--            <b class="red"></b>-->
    <!--            <span class="line-text">物业公司：</span>-->
    <!--          </div>-->
    <!--          <div class="line-info">-->
    <!--            <el-input v-model="propertyCompany" size="small" style="width: 220px" />-->
    <!--          </div>-->
    <!--        </div>-->
    <!--        <div style="display: flex;justify-content: flex-start;">-->
    <!--          <div class="textBox">-->
    <!--            <b class="red"></b>-->
    <!--            <span class="line-text">交付运营时间：</span>-->
    <!--          </div>-->
    <!--          <div class="line-info">-->
    <!--            <el-date-picker-->
    <!--              v-model="startOperationTime"-->
    <!--              value-format="yyyy-MM-dd"-->
    <!--              type="date"-->
    <!--              size="small"-->
    <!--              style="width: 220px"-->
    <!--              placeholder="选择日期">-->
    <!--            </el-date-picker>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--        <div style="display: flex;justify-content: flex-start;">-->
    <!--          <div class="textBox">-->
    <!--            <b class="red"></b>-->
    <!--            <span class="line-text">交付标准：</span>-->
    <!--          </div>-->
    <!--          <div class="line-info">-->
    <!--            <el-select v-model="roomDecoration" placeholder="请选择" size="mini" style="width: 220px">-->
    <!--              <el-option v-for="item in roomDecorationList" :key="item.value" :label="item.name" :value="item.value" />-->
    <!--            </el-select>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </div>-->

    <!--      <div class="form-line">-->
    <!--        <div style="display: flex;justify-content: flex-start;">-->
    <!--          <div class="textBox">-->
    <!--            <b class="red"></b>-->
    <!--            <span class="line-text">公寓租赁单价：</span>-->
    <!--          </div>-->
    <!--          <div class="line-info" style="line-height: 35px">-->
    <!--            <el-input v-model="yqUnitPrice" size="small" style="width: 220px">-->
    <!--              <template slot="append">元 / m² / 天</template>-->
    <!--            </el-input>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--        <div style="display: flex;justify-content: flex-start;">-->
    <!--          <div class="textBox">-->
    <!--            <b class="red"></b>-->
    <!--            <span class="line-text">公寓物业单价：</span>-->
    <!--          </div>-->
    <!--          <div class="line-info" style="line-height: 35px">-->
    <!--            <el-input v-model="propertyFee" size="small" style="width: 220px">-->
    <!--              <template slot="append">元 / m² / 天</template>-->
    <!--            </el-input>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--        <div style="width: 330px"></div>-->
    <!--      </div>-->

    <!--      <div class="form-line">-->
    <!--        <div style="display: flex;justify-content: flex-start;">-->
    <!--          <div class="textBox">-->
    <!--            <b class="red"></b>-->
    <!--            <span class="line-text">公寓标签：</span>-->
    <!--          </div>-->
    <!--          <div class="line-info" style="flex: 1;line-height: 35px;width: auto;display: flex;justify-content: flex-start;flex-wrap:wrap;align-items: center;">-->
    <!--            <el-tag-->
    <!--              :key="tag"-->
    <!--              v-for="tag in dynamicTags"-->
    <!--              closable-->
    <!--              :disable-transitions="false"-->
    <!--              @close="handleClose(tag)">-->
    <!--              {{tag}}-->
    <!--            </el-tag>-->
    <!--            <el-input-->
    <!--              class="input-new-tag"-->
    <!--              v-if="inputVisible"-->
    <!--              v-model="inputValue"-->
    <!--              ref="saveTagInput"-->
    <!--              size="small"-->
    <!--              @keyup.enter.native="handleInputConfirm"-->
    <!--              @blur="handleInputConfirm"-->
    <!--            >-->
    <!--            </el-input>-->
    <!--            <el-button v-else class="button-new-tag" size="small" @click="showInput">添加新标签</el-button>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--      -->
    <!--      <div class="form-line" style="margin-top: 25px;">-->
    <!--        <div>-->
    <!--          <div class="textBox" style="line-height: initial">-->
    <!--            <b class="red">*</b>-->
    <!--            <span class="line-text">公寓介绍：</span>-->
    <!--          </div>-->
    <!--          <el-input v-model="yqIntroduce" type="textarea" :rows="5" size="small" style="width: 640px" />-->
    <!--        </div>-->
    <!--      </div>-->
    <!--      <div class="form-line">-->
    <!--        <div>-->
    <!--          <div class="textBox" style="line-height: initial;padding: 10px 0 0 0;">-->
    <!--            <b class="red">*</b>-->
    <!--            <span class="line-text">公寓展示图：</span>-->
    <!--          </div>-->
    <!--          <upload-img-list @getImgList="getImgList" :defaultImg="defaultImg" />-->
    <!--        </div>-->
    <!--      </div>-->

    <!--      <div class="form-line">-->
    <!--        <div>-->
    <!--          <div class="textBox" style="line-height: initial;padding: 10px 0 0 0;">-->
    <!--            <span class="line-text">公寓户型图：</span>-->
    <!--          </div>-->
    <!--          <upload-img-list @getImgList="getApartmentLayoutImgList" :defaultImg="defaultApartmentLayoutImg" />-->
    <!--        </div>-->
    <!--      </div>-->

    <!--      <div class="form-line" style="margin: 40px 0;">-->
    <!--        <div>-->
    <!--          <div class="textBox" style="line-height: initial">-->
    <!--            <b class="red">*</b>-->
    <!--            <span class="line-text">公寓地址：</span>-->
    <!--          </div>-->
    <!--          <garden-map :isModify="true" :defaultAdd="yqAddress" :longitude="longitude" :latitude="latitude" @getAddress="getAddress" />-->
    <!--        </div>-->
    <!--      </div>-->

    <!--    </form>-->
  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import TextTitle from "../../../components/Text/TextTitle";
import { getObjectURL } from "../../../utils/toBase64";
import $ from "jquery";
import { api } from "../../api/ConfigRoutine";
import { errorHandler } from "../../../utils/errorHandler";
import { nError, nSuccess } from "../../../utils/notice";
import GardenMap from "../../../components/Map/GardenMap";
import UploadImgList from "../../../components/Input/UploadImgList";

const toolbarOptions = [
  ["bold", "italic", "underline", "strike"], // toggled buttons
  ["blockquote", "code-block"],

  [{ header: 1 }, { header: 2 }], // custom button values
  [{ list: "ordered" }, { list: "bullet" }],
  [{ script: "sub" }, { script: "super" }], // superscript/subscript
  [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
  [{ direction: "rtl" }], // text direction

  [{ size: ["small", false, "large", "huge"] }], // custom dropdown
  [{ header: [1, 2, 3, 4, 5, 6, false] }],

  [{ color: [] }, { background: [] }], // dropdown with defaults from theme
  [{ font: [] }],
  [{ align: [] }],
  ["link", "image"],
  ["clean"], // remove formatting button
];

export default {
  components: {
    UploadImgList,
    GardenMap,
    TextTitle,
    Breadcrumb,
  },
  name: "modify-yq-information",
  data() {
    return {
      breadcrumb: [
        {
          value: "资源中心",
          name: "yq-information",
        },
        {
          value: "公寓介绍",
        },
      ],
      mainTitle: "公寓信息",
      // subheading: '设置接入公寓的名称，公寓背景图等',
      defaultImg: [],
      imageList: [],
      base64List: [],

      defaultApartmentLayoutImg: [],
      apartmentLayoutImageList: [],
      apartmentLayoutBase64List: [],

      yqName: "", // 公寓名称
      yqCode: "",
      yqLogo: "",
      yqLogoBase64: "",
      managerPhone: "", // 公寓联系方式
      yqTotalArea: "", // 公寓总面积
      yqIntroduce: "", // 公寓介绍
      yqIconUrl: "", // 公寓logo
      yqBackgroundUrl: "", // 公寓背景图
      yqAddress: "",
      longitude: "",
      latitude: "",

      propertyCompany: "",
      startOperationTime: "",
      commissionRules: "",
      floorStandardHigh: "",
      floorStandardArea: "",
      roomDecoration: "",
      yqUnitPrice: "",
      propertyFee: "",
      yqTaps: "",

      roomDecorationList: [
        { name: "精装", value: "精装" },
        { name: "中装", value: "中装" },
        { name: "简装", value: "简装" },
      ],

      dynamicTags: [],
      inputVisible: false,
      inputValue: "",

      editorOption: {
        modules: {
          toolbar: {
            container: toolbarOptions, // 工具栏
            handlers: {
              image: function (value) {
                if (value) {
                  document.querySelector("#showImageDialogVisible").click();
                } else {
                  this.quill.format("image", false);
                }
              },
            },
          },
        },
      },
    };
  },
  created() {
    this.getYqInfo();
  },
  methods: {
    onEditorBlur(editor) {},
    onEditorFocus(editor) {},
    onEditorReady(editor) {},
    onEditorChange({ editor, html, text }) {
      // console.log('editor change!', editor, html, text)
      this.content = html;
    },

    handleClose(tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },

    showInput() {
      this.inputVisible = true;
      this.$nextTick((_) => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },

    handleInputConfirm() {
      let inputValue = this.inputValue;
      if (inputValue) {
        this.dynamicTags.push(inputValue);
      }
      this.inputVisible = false;
      this.inputValue = "";
    },
    toConfigRoutinePage() {
      this.$router.push({
        name: "yq-information",
      });
    },
    upData2: function () {
      let that = this;
      const oFReader = new FileReader();
      const file = document.getElementById("uploadBackgroundImg").files[0];
      if (file.size > 1024 * 1024) {
        nError("上传图片不能大于1M");
        return false;
      }
      oFReader.readAsDataURL(file);
      oFReader.onloadend = function (oFRevent) {
        const src = oFRevent.target.result;
        that.yqLogoBase64 = src;
        that.uploadPicture();
      };
    },
    upImg2: function () {
      $("#uploadBackgroundImg")
        .click() // 隐藏了input:file样式后，点击头像就可以本地上传
        .on("change", function () {
          // const objUrl = getObjectURL(this.files[0])
          // if (objUrl) {
          //   $('#pic2').attr('src', objUrl)
          // }
        });
    },
    // 上传图片
    uploadPicture() {
      this.$axios
        .post(api.uploadImg, {
          picData: this.yqLogoBase64,
        })
        .then((res) => {
          if (res.data.retCode === 1) {
            this.yqLogo = res.data.data;
          } else {
            // 提示信息，需引入Message
            nError("图片上传失败");
          }
        })
        .catch(errorHandler("图片上传失败"));
    },

    // 上传图片
    uploadPictureToGetUrl(base64) {
      return this.$axios.post(api.uploadImg, {
        picData: base64,
      });
    },

    getYqInfo() {
      this.$axios
        .post(api.getYqInfo, {})
        .then((res) => {
          if (res.data.retCode === 1) {
            let data = res.data.data;
            this.yqName = data.yqName;
            this.yqCode = data.yqCode;
            this.yqLogo = data.yqLogo;
            this.managerPhone = data.managerPhone;
            this.yqIntroduce = decodeURI(data.yqIntroduce);
            this.yqTotalArea = data.yqTotalArea;
            // this.yqBackgroundUrl = data.yqBackgroundUrl
            this.yqAddress = data.yqAddress;
            this.longitude = data.longitude;
            this.latitude = data.latitude;
            this.propertyCompany = data.propertyCompany;
            this.startOperationTime = data.startOperationTime;
            this.commissionRules = data.commissionRules;
            this.floorStandardHigh = data.floorStandardHigh;
            this.floorStandardArea = data.floorStandardArea;
            this.roomDecoration = data.roomDecoration;
            this.yqUnitPrice = data.yqUnitPrice;
            this.propertyFee = data.propertyFee;
            this.yqTaps = data.yqTaps;
            if (data.yqApartmentLayoutDiagramList) {
              this.defaultApartmentLayoutImg = data.yqApartmentLayoutDiagramList.split(
                ","
              );
            }

            if (data.yqTaps) {
              this.dynamicTags = data.yqTaps.split("&&");
            }
            if (data.yqPic1) {
              this.defaultImg.push(data.yqPic1);
            }
            if (data.yqPic2) {
              this.defaultImg.push(data.yqPic2);
            }
            if (data.yqPic3) {
              this.defaultImg.push(data.yqPic3);
            }
            if (data.yqPic4) {
              this.defaultImg.push(data.yqPic4);
            }
            if (data.yqPic5) {
              this.defaultImg.push(data.yqPic5);
            }
          }
        })
        .catch(errorHandler("查询公寓信息失败"));
    },
    getImgList(imageList, base64List) {
      this.imageList = imageList;
      this.base64List = base64List;
    },
    getApartmentLayoutImgList(imageList, base64List) {
      this.apartmentLayoutImageList = imageList;
      this.apartmentLayoutBase64List = base64List;
    },
    getAddress(yqAddress, longitude, latitude) {
      this.yqAddress = yqAddress;
      this.longitude = longitude.toString();
      this.latitude = latitude.toString();
    },
    async upApartmentLayoutImageList() {
      let yqApartmentLayoutDiagramListArr = [];
      for (let k = 0; k < this.apartmentLayoutImageList.length; k++) {
        if (!this.apartmentLayoutImageList[k].name) {
          yqApartmentLayoutDiagramListArr.push(
            this.apartmentLayoutImageList[k].src
          );
        }
        for (let j = 0; j < this.apartmentLayoutBase64List.length; j++) {
          if (
            this.apartmentLayoutImageList[k].name &&
            this.apartmentLayoutImageList[k].name.split(".")[0] ===
              this.apartmentLayoutBase64List[j].code
          ) {
            let imgUrl = "";
            await this.uploadPictureToGetUrl(
              this.apartmentLayoutBase64List[j].personImageStr
            )
              .then((res) => {
                imgUrl = res.data.data;
              })
              .catch(errorHandler("图片上传失败"));
            yqApartmentLayoutDiagramListArr.push(imgUrl);
          }
        }
      }
      this.yqApartmentLayoutDiagramListArr = yqApartmentLayoutDiagramListArr;
    },
    async updateyqInfo() {
      await this.upApartmentLayoutImageList();
      let sendList = [];
      for (let k = 0; k < this.imageList.length; k++) {
        if (!this.imageList[k].name) {
          let obj = {
            personImageStr: "",
          };
          obj.personImageStr = this.imageList[k].src;
          sendList.push(obj);
        }
        for (let j = 0; j < this.base64List.length; j++) {
          if (
            this.imageList[k].name &&
            this.imageList[k].name.split(".")[0] === this.base64List[j].code
          ) {
            sendList.push(this.base64List[j]);
          }
        }
      }
      if (sendList.length === 0) {
        nError("请至少选择一张图片！");
        return false;
      }
      if (!this.managerPhone) {
        nError("请输入公寓联系方式");
        return false;
      }
      if (!this.yqIntroduce) {
        nError("请输入公寓介绍");
        return false;
      }
      // if (!this.yqAddress) {
      //   nError("请输入公寓地址");
      //   return false;
      // }
      // if (!this.longitude || !this.latitude) {
      //   nError("请在地图上选取准确地址");
      //   return false;
      // }
      const loading = this.$loading({
        lock: true,
        text: "请稍后",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let reqData = {
        yqPic1: "",
        yqPic2: "",
        yqPic3: "",
        yqPic4: "",
        yqPic5: "",
      };
      for (let p = 0; p < sendList.length; p++) {
        let key = `yqPic${p + 1}`;
        reqData[key] = sendList[p].personImageStr;
      }
      reqData.yqName = this.yqName;
      reqData.yqLogo = this.yqLogo;
      reqData.yqIntroduce = encodeURI(this.yqIntroduce);
      reqData.yqTotalArea = this.yqTotalArea;
      reqData.managerPhone = this.managerPhone;
      reqData.yqAddress = this.yqAddress;
      reqData.longitude = this.longitude;
      reqData.latitude = this.latitude;
      reqData.yqCode = this.yqCode;

      reqData.propertyCompany = this.propertyCompany;
      reqData.startOperationTime = this.startOperationTime;
      reqData.commissionRules = this.commissionRules;
      reqData.floorStandardHigh = this.floorStandardHigh;
      reqData.floorStandardArea = this.floorStandardArea;
      reqData.roomDecoration = this.roomDecoration;
      reqData.yqUnitPrice = this.yqUnitPrice;
      reqData.propertyFee = this.propertyFee;
      reqData.yqTaps = this.dynamicTags.join("&&");
      if (this.yqApartmentLayoutDiagramListArr.length > 0) {
        reqData.yqApartmentLayoutDiagramList = this.yqApartmentLayoutDiagramListArr.join(
          ","
        );
      } else {
        reqData.yqApartmentLayoutDiagramList = "";
      }
      // let yqBackgroundUrl
      // let yqIconUrl
      // if (this.yqBackgroundUrl.indexOf('https://oss.damaiiot.com') !== -1) {
      //   yqBackgroundUrl = ''
      // } else {
      //   yqBackgroundUrl = this.yqBackgroundUrl
      // }
      // if (this.yqIconUrl.indexOf('https://oss.damaiiot.com') !== -1) {
      //   yqIconUrl = ''
      // } else {
      //   yqIconUrl = this.yqIconUrl
      // }
      this.$axios
        .post(api.updateyqInfo, reqData)
        .then((res) => {
          if (res.data.retCode === 1) {
            nSuccess("修改成功");
            this.toConfigRoutinePage();
            loading.close();
          }
        })
        .catch(errorHandler("修改公寓信息失败"))
        .then(() => {
          loading.close();
        });
    },
  },
};
</script>

<style scoped>
.flexBox {
  display: flex;
  justify-content: space-between;
}
.header-btn-box {
  margin: 20px 0 10px 0;
  color: #337ab7;
  font-size: 14px;
}
.header-btn-box a {
  margin-right: 40px;
  cursor: pointer;
}
.header-btn-box a:hover {
  color: #00a0e6;
}
form {
  width: 96%;
  margin: 0 auto;
  text-align: left;
}
.red {
  color: #ff0000;
  vertical-align: top;
}
.form-line {
  margin: 10px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.form-line > div {
  display: flex;
  justify-content: flex-start;
}
.line-text {
  color: #48576a;
  font-size: 14px;
  width: 120px;
  text-align: right;
}
.form-title {
  color: #333;
  font-size: 16px;
  line-height: 28px;
  padding-left: 5px;
  border-left: 3px solid #00a0e6;
}
.textBox {
  display: inline-block;
  width: 120px;
  text-align: right;
}
.line-info {
  width: 280px;
}
.form-btn-box {
  width: 330px;
  padding: 0 124px;
  margin-top: 40px;
  display: flex;
  justify-content: space-between;
}

.newly {
  display: inline-block;
  width: 64px;
  height: 64px;
  vertical-align: text-top;
  border: 1px dashed #d7d7d7;
  margin-right: 20px;
  position: relative;
}

.newly2 {
  display: inline-block;
  width: auto;
  height: 50px;
  vertical-align: text-top;
  border: 1px dashed #d7d7d7;
  position: relative;
}

#pic {
  width: 64px;
  height: 64px;
}

.newly span {
  display: block;
  width: 100%;
  color: #999999;
  margin: 0;
  padding: 0;
  text-align: center;
}

.newly2 span {
  display: block;
  width: 100%;
  color: #999999;
  margin: 0;
  padding: 0;
  text-align: center;
}

.newly span:first-child {
  font-size: 12px;
  line-height: 20px;
  position: absolute;
  top: 15px;
}

.newly2 span:first-child {
  font-size: 20px;
  line-height: 60px;
  position: absolute;
}

.newly span:last-child {
  font-size: 14px;
  line-height: 20px;
  position: absolute;
  bottom: 0;
}

.newly2 span:last-child {
  font-size: 12px;
  line-height: 20px;
  position: absolute;
  bottom: 0;
}

.upload {
  display: inline-block;
  width: 80px;
  height: 80px;
  vertical-align: text-top;
  background-size: 100% 100%;
  border: 1px dashed #eeeeee;
  position: relative;
}

.upload span {
  display: block;
  line-height: 60px;
  text-align: center;
  color: #999999;
  font-size: 20px;
}

.upload2 {
  display: block;
  width: 80px;
  height: 80px;
  vertical-align: text-top;
  background-size: 100% 100%;
  position: relative;
}

.upload img,
.upload2 img {
  width: auto;
  height: 100%;
  border-radius: 5px;
}

.upload b {
  display: inline-block;
  width: 100%;
  line-height: 21px;
  font-size: 12px;
  color: white;
  background-color: #989796;
  text-align: center;
  position: absolute;
  left: 0;
  bottom: 0;
  opacity: 0.7;
}

.upload2 b {
  display: inline-block;
  width: 100%;
  line-height: 21px;
  font-size: 12px;
  color: white;
  background-color: #989796;
  text-align: center;
  position: absolute;
  left: 0;
  bottom: 0;
  opacity: 0.7;
}

.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin: 10px 0 10px 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
</style>

<style lang="less">
.yq-information-modify {
  .yq-information-modify-form {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    height: 740px;
    .form-top-text {
      font-size: 16px;
      padding: 0 10px;
      line-height: 40px;
      // background: #eeeeee;
      i {
        font-size: 18px;
        margin-right: 10px;
      }
    }
    .form-left {
      border-radius: 7px;
      width: 420px;
      height: 100%;
      margin-right: 30px;
      border: 1px solid #eeeeee;
      overflow-y: auto;
      .form-left-line {
        margin: 10px 0;
        display: flex;
        justify-content: flex-start;
        align-items: center;
      }
    }
    .form-right {
      flex: 1;
      height: 100%;
      display: flex;
      justify-content: flex-start;
      flex-direction: column;
      .form-right-top {
        margin-bottom: 30px;
        border-radius: 7px;
        border: 1px solid #eeeeee;
      }
      .form-right-bottom {
        flex: 1;
        border-radius: 7px;
        border: 1px solid #eeeeee;
        display: flex;
        justify-content: flex-start;
        flex-direction: column;
        .editorBox {
          flex: 1;
          /deep/ .ql-editor {
            display: flex;
            justify-content: flex-start;
            flex-direction: column;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/ResourceCenter/YqInformation/ModifyYqInformation.vue